import { Injectable } from '@angular/core';
import { ConfigService } from 'app/config.service';
import { UserService } from './user.service';
import * as GripCDP from 'grip-cdp-tracker';

export enum ConversionButtonLocationEnum {
  conversion_modal = 'conversion_modal',
  top_navigation = 'top_navigation',
}

@Injectable({
  providedIn: 'root'
})
export class GuestConversionService {
  constructor(
    private configService: ConfigService,
    private userService: UserService,
  ) {}

  public showConversionModal(): void {
    if (this.configService.modalGuestConversionState) {
      return;
    }

    this.configService.modalGuestConversionState = true;

    this.trackCDPEvent(
      'open',
      'ui',
      ConversionButtonLocationEnum.conversion_modal
    );
  }

  public hideConversionModal(): void {
    if (!this.configService.modalGuestConversionState) {
      return;
    }

    this.configService.modalGuestConversionState = false;

    this.trackCDPEvent(
      'click',
      'ui',
      'cancel_conversion',
      {
        utm_source: ConversionButtonLocationEnum.conversion_modal
      }
    );
  }

  public onLoginButtonClick(buttonLocation: ConversionButtonLocationEnum): void {
    this.trackCDPEvent(
      'click',
      'ui',
      'login',
      {
        utm_source: buttonLocation,
        utm_term: this.configService.communityInfo.login_btn_text
      }
    );

    this.userService.triggerSignOutSubject.next();
  }

  public onBuyTicketButtonClick(buttonLocation: ConversionButtonLocationEnum): void {
    this.trackCDPEvent(
      'click',
      'ui',
      'buy_ticket',
      {
        utm_source: buttonLocation,
        utm_term: this.configService.communityInfo.buy_ticket_btn_text
      }
    );

    window.open(
      this.configService.communityInfo.buy_ticket_btn_link,
      '_blank',
      'noopener,noreferrer'
    );
  }

  private trackCDPEvent(
    event: string,
    to_type: string,
    to_id: string | number,
    meta?: Record<string, unknown>
  ): void {
    try {
      GripCDP.trackEvent(event, to_type, to_id, meta);
    } catch(e) {
      console.warn('CDP track event fail: ', e);
    }
  }
}
